<template>
  <div>
    
    <!-- Header -->
    <div class="header">
      <div class="container">
        <div class="header-cards"
                :style="'border-bottom: 12px solid '+row.lineColor1+' !important'">
          <div class="header-view" 
                :style="'background-image: url('+row.image1+')'"></div>
          <div class="header-details"
                :style="'background: '+row.bgColor1+' !important'">
            <div class="sub-title mb-2"
                v-html="row.subTitle1"
                :style="'color:'+row.subTitleColor1+' !important'">
            </div>
            <div class="bg-title mb-3"
                v-html="row.title1"
                :style="'color:'+row.titleColor1+' !important'">
            </div>
            <router-link v-if="row.button1" :to="row.redirect1"
                class="btn-square btn-square-white">{{ row.button1 }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Header -->

  </div>
</template>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
